import styled from 'styled-components';

import { ExpandableTable } from '@thinknet-gmbh/platform-common-ui';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 22px;
  & > div:last-child {
    display: flex;
    & > div:first-child {
      margin-right: 15px;
    }
  }
`;

export const MainWrapper = styled.div``;

export const StyledExpandableTable = styled(ExpandableTable)`
  .ant-table-content .ant-table-tbody {
    .ant-table-expanded-row td > div {
      padding: 0;
    }
    .ant-table-row td > div {
      padding: 9px 12px;
    }
  }
`;
